export async function getAddress(request) {
    const address = await request({
        url: "/profile/address",
        method: "get"
      });
    return address;
}

export async function updateAddress(request, address) {
    const up_address = await request({
        method: "post",
        url: "/profile/address",
        data: {
            address
        }
      });
    return up_address;
}

export async function setLocation(request, locArgs) {
  const upLocation = await request({
    method: "post",
    url: "/set-location",
    params: {
      lat: locArgs.lat,
      lng: locArgs.lng,
      quality: locArgs.quality
    }
  });
  return upLocation;
}
